import { createApp } from "vue";
import App from "./App.vue";
import { setupRouter } from "/@/router";
import { setupStore } from "/@/store";
import { setupDirections } from "/@/directives";

import "/@/design/index.less";
import "virtual:uno.css";
import "virtual:svg-icons-register";

const app = createApp(App);
setupStore(app);
setupRouter(app);
setupDirections(app);
app.mount("#app");
